<script lang="ts">
  import { onMount } from "svelte";
  import { push, link } from "svelte-spa-router";
  import { listSchools, ApiError } from "../lib/api";
  import Breadcrumb from "../lib/Breadcrumb.svelte";
  import type { School } from "@diy-avatar/shared/admin";

  let schools: School[] = [];
  let loading = false;
  let error: string | null = null;

  async function load() {
    loading = true;
    try {
      schools = (await listSchools()).schools;
      error = null;
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        push("/");
        return;
      }
      error = err instanceof Error ? err.message : "Could not load schools.";
    } finally {
      loading = false;
    }
  }

  onMount(load);
</script>

<section>
  <Breadcrumb items={[{ label: "Schools" }]} />
  <h1>Schools</h1>
  {#if error}<p class="error" data-testid="error">{error}</p>{/if}

  <table data-testid="schools-table">
    <thead>
      <tr><th>id</th><th>name</th><th>authority</th><th>description</th><th></th></tr>
    </thead>
    <tbody>
      {#each schools as s (s.id)}
        <tr data-testid="school-row-{s.id}">
          <td>#{s.id}</td>
          <td>
            <a href="/schools/{s.id}" use:link data-testid="school-link-{s.id}">{s.name}</a>
          </td>
          <td>{s.authority_name ?? s.authority_id}</td>
          <td>{s.description ?? "—"}</td>
          <td>
            <a href="/schools/{s.id}" use:link>Open →</a>
          </td>
        </tr>
      {/each}
      {#if schools.length === 0 && !loading}
        <tr><td colspan="5" class="empty">No schools.</td></tr>
      {/if}
    </tbody>
  </table>
</section>

<style>
  h1 { margin: 0 0 1rem; }
  table { width: 100%; border-collapse: collapse; background: #111827; }
  th, td {
    padding: 0.4rem 0.6rem;
    text-align: left;
    border-bottom: 1px solid #1f2937;
    font-size: 0.85rem;
  }
  th { background: #0f172a; color: #9ca3af; }
  td a { color: #34d399; text-decoration: none; }
  td a:hover { text-decoration: underline; }
  .empty { color: #6b7280; text-align: center; }
  .error { color: #fca5a5; }
</style>
